import getScrollPosition from '../media/getScrollPosition';
import getHeaderOffset from '../media/getHeaderOffset';
import getElementTop from '../elements/getElementTop';
import getPerformanceNow from './performance';

export const SCROLL_DURATION = 500;
export const SCROLL_TOP = 0;

//
//position accepts either an integer or an element
//If an element is supplied then the top is calculated as the scroll position target
//
export default function scrollTo(position = SCROLL_TOP, duration = SCROLL_DURATION, callback) {
  let targetPosition;

  if(position instanceof Element) {
    targetPosition = getElementTop(position) - getHeaderOffset();
  } else {
    targetPosition = position;
  }

  const initialY = getScrollPosition(),
        baseY = (initialY + targetPosition) * 0.5,
        difference = initialY - baseY,
        startTime = getPerformanceNow();

  function step() {
    const now = getPerformanceNow();
    const normalizedTime = Math.min(parseFloat(now - startTime) / duration, 1);

    window.scrollTo(0, baseY + difference * Math.cos(normalizedTime * Math.PI));

    if (normalizedTime < 1) {
      requestAnimationFrame(step);
    } else {
      callback && callback();
    }
  }

  requestAnimationFrame(step);
}
